module.exports = {"rsvp":{"status":{"listed":"#e0e0e0","invited":"#967adc","requested":"#f5b858","waitlisted":"#40c4f1","confirmed":"#73ccb9","cancelled":"#ed5565"}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/components/deposits/colors.json
// module id = 143
// module chunks = 1